module.exports = __webpack_public_path__ + "static/svajnyj-fundament-2bc355b0528cbbab2dd36de93ea333ae.jpg";